export enum DtoSignalREndpoints {
  RegisterService = "RegisterService",
  DtoUpdate = "DtoUpdate"
}
